import React from 'react';

const FeeWallet = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12.5" cy="16.5" r="12.5" fill="#EFE5FF" />
    <path
      d="M7.42 14.35C7.42 12.94 8.41 11.845 9.895 11.845C11.395 11.845 12.4 12.94 12.4 14.35C12.4 15.745 11.395 16.81 9.895 16.81C8.41 16.81 7.42 15.745 7.42 14.35ZM8.935 22L15.325 11.995H16.33L9.925 22H8.935ZM11.23 14.35C11.23 13.45 10.675 12.85 9.895 12.85C9.13 12.85 8.575 13.45 8.575 14.35C8.575 15.205 9.13 15.82 9.895 15.82C10.675 15.82 11.23 15.205 11.23 14.35ZM12.805 19.72C12.805 18.31 13.795 17.215 15.28 17.215C16.765 17.215 17.77 18.31 17.77 19.72C17.77 21.115 16.765 22.18 15.28 22.18C13.795 22.18 12.805 21.115 12.805 19.72ZM16.615 19.72C16.615 18.82 16.06 18.22 15.28 18.22C14.5 18.22 13.96 18.82 13.96 19.72C13.96 20.59 14.5 21.19 15.28 21.19C16.06 21.19 16.615 20.59 16.615 19.72Z"
      fill="#6930CA"
    />
  </svg>
);

export default FeeWallet;
